import React from "react";
import comingSoon from "../assets/coming-soon.jpg";
import logo from "../assets/logo-1.png";

const ComingSoon = () => {
  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${comingSoon})`,
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900/80 to-slate-800/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center text-white max-w-4xl mx-auto px-6">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img className="h-20 w-auto" src={logo} alt="SM Constructions" />
        </div>

        {/* Main Content */}
        <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
          Something Amazing
          <span className="block text-amber-400">Is Coming Soon</span>
        </h1>

        <p className="text-xl md:text-2xl mb-8 text-gray-200 leading-relaxed max-w-2xl mx-auto">
          We're crafting an exceptional experience for premium windows and
          doors. Get ready for the transformation.
        </p>

        {/* Contact Info */}
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-12">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-amber-500 rounded-full flex items-center justify-center">
              <svg
                className="w-5 h-5 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                />
              </svg>
            </div>
            <div className="text-left">
              <div className="text-lg font-semibold">Call Us</div>
              <div className="text-amber-400">+1 (289) 200-3498</div>
            </div>
          </div>

          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-amber-500 rounded-full flex items-center justify-center">
              <svg
                className="w-5 h-5 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
            </div>
            <div className="text-left">
              <div className="text-lg font-semibold">Email Us</div>
              <div className="text-amber-400">info@smconstructions.ca</div>
            </div>
          </div>
        </div>

        {/* Notify Button */}
        <div className="max-w-md mx-auto">
          <div className="flex flex-col sm:flex-row gap-3">
            <input
              type="email"
              placeholder="Enter your email for updates"
              className="flex-1 px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white placeholder-gray-300 backdrop-blur-sm focus:outline-none focus:ring-2 focus:ring-amber-400"
            />
            <button className="bg-amber-500 hover:bg-amber-600 text-black font-semibold px-8 py-3 rounded-lg transition duration-300 transform hover:scale-105">
              Notify Me
            </button>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-20 right-20 w-32 h-32 bg-amber-400/10 rounded-full animate-pulse"></div>
      <div className="absolute bottom-32 left-20 w-24 h-24 bg-blue-400/10 rounded-full animate-pulse delay-700"></div>
      <div className="absolute top-1/2 right-10 w-16 h-16 bg-white/10 rounded-full animate-pulse delay-1000"></div>
    </div>
  );
};

export default ComingSoon;
